import { HTMLAttributes } from 'react';
import { OneOrMoreReactElements } from '../../types';
import { joinClassNames } from '../../utils';
import { ColProps } from './Col';
import styles from './styles.module.scss';

export type RowProps = HTMLAttributes<HTMLDivElement> & {
  children: OneOrMoreReactElements<ColProps>;
};

export const Row = ({ children, className, ...props }: RowProps) => (
  <div className={joinClassNames(styles.row, className)} {...props}>
    {children}
  </div>
);
